import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './navbar.css';
import { useNavigate } from 'react-router';
function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => {
    setClick(false);
    document.getElementsByClassName('MobileRows')[0].classList.toggle('openerMob')
  };

  // const showButton = () => {
  //   if (window.innerWidth <= 960) {
  //     setButton(false);
  //   } else {
  //     setButton(true);
  //   }
  // };

  useEffect(() => {
    // window.addEventListener('resize', showButton);
    // showButton();
  }, []);
  let navigate = useNavigate();
  function scroller(label) {
    document.getElementById(label).scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
  function open() {
    document.getElementsByClassName('MobileRows')[0].classList.toggle('openerMob')
  }
  return (
    <>
      <nav className='navbar asd'>
        <div className='navbar-container'>
          <div className="company">
            <div><img alt='' src='../../IMAGES/logo1.png' /></div>
            <div className='row company-name'>
              <img src={require('../../IMAGES/logo1.png')}></img>
              <div style={{ paddingLeft: '5px' }}>
                <h3 style={{ fontSize: '30px', letterSpacing: '1px' }}>FLYXAVI</h3>
                <h5>AVIATION SERVICES</h5>
              </div>
            </div>
          </div>
          <div className='menu-icon' onClick={() => { open(); handleClick(); }}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
          <span className='MobileRows'>
            <ul className={click ? 'navnu active' : 'navnu'}>
              <li className='nav-item'>
                <Link to='/' className='nav-links' onClick={() => { closeMobileMenu(); scroller('home') }}>
                  HOME
                </Link>
              </li>
              <li className='nav-item'>
                <Link
                  to='#about'
                  className='nav-links'
                  onClick={() => { closeMobileMenu(); scroller('about') }}
                >
                  ABOUT
                </Link>
              </li>
              <li className='nav-item'>
                <Link
                  to='/'
                  className='nav-links'
                  onClick={() => { closeMobileMenu(); scroller('services') }}
                >
                  SERVICES
                </Link>
              </li>
              <li className='nav-item'>
                <Link
                  to='/'
                  className='nav-links'
                  onClick={() => { closeMobileMenu(); scroller('carrer') }}
                >
                  CARRIER
                </Link>
              </li>
              <li className='nav-item'>
                <Link
                  to='/'
                  className='nav-links'
                  onClick={() => { closeMobileMenu(); scroller('footer') }}
                >
                  CONTACT US
                </Link>
              </li>
              <li className='nav-item'>
                <Link
                  to='/SignIn'
                  className='nav-links'
                  onClick={closeMobileMenu}
                >
                  LOGIN
                </Link>
              </li>
            </ul>
            <Button classes='HomeSiBut' onClick={() => navigate('/SignUp')} >SIGN UP</Button>
          </span>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
